import { type AxiosError, AxiosHeaders } from 'axios'
import useSWRMutation, { type SWRMutationResponse } from 'swr/mutation'

import {
  ContactControllerApiFactory,
  type RXVideoRequestV1,
} from '@redteclab/api/clients/bully'

import { useGlooApi } from '../../api'
import { useGlobalConfigContext } from '../../global-config'

const getUseApiSwrMediServiceContactRxVideoPostMutation = (): string =>
  'useApiSwrMediServiceContactRxVideoPostMutation'

export const useApiSwrMediServiceContactRxVideoPostMutation =
  (): SWRMutationResponse<unknown, AxiosError, string, RXVideoRequestV1> => {
    const globalConfig = useGlobalConfigContext()
    const client = useGlooApi(ContactControllerApiFactory)

    return useSWRMutation(
      getUseApiSwrMediServiceContactRxVideoPostMutation(),
      async (
        _swrKey: string,
        data: { arg: RXVideoRequestV1 },
      ): Promise<unknown> => {
        const response = await client.contactV1TenantLanguageRxVideoPost({
          language: globalConfig.language,
          RXVideoRequestV1: data.arg,
          tenant: globalConfig.tenantAndEnv,
        })

        return response.headers instanceof AxiosHeaders
          ? response.headers.get('date')
          : ''
      },
    )
  }
